'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _utils = require('shared/components/Page/utils');

var _Step = require('./Step');

var _Step2 = _interopRequireDefault(_Step);

var _selectors = require('./selectors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function JobNextSteps(_ref) {
  var moduleClass = _ref.moduleClass,
      title = _ref.title,
      image = _ref.image,
      loading = _ref.loading,
      steps = _ref.steps;

  return _react2.default.createElement(
    'div',
    {
      className: 'type-job_next_steps ' + moduleClass
    },
    (0, _utils.getImage)(image),
    _react2.default.createElement(
      'div',
      { className: 'contents' },
      steps.map(function (step, key) {
        return _react2.default.createElement(_Step2.default, {
          key: key,
          title: step.title,
          text: step.text,
          linkText: step.linkText,
          href: step.href,
          loading: loading
        });
      })
    )
  );
} /*
    {
      "type": "job_next_steps",
      "title": "Next steps for this job",
      "image": {
        "url": "http://placeimg.com/300/300/animals",
        "title": "Photo Title",
        "alt": "Photo alt"
      }
    }
  
    This is for rendering the Job Next Steps on the job description template.
  
    `title` will render the main title and `image` will
    render the checkbox.
  */

exports.default = (0, _reactRedux.connect)(_selectors.mapStateToProps)(JobNextSteps);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/JobNextSteps/JobNextSteps.jsx
// module id = 1207
// module chunks = 0